module.exports = __webpack_public_path__ + "static/media/linkedin.091dc9c2.svg";